export const environment = {
    production: true,
    appcode: 'INHelpDe',
    //serviceBaseUrl: 'https://INGURVMUAPPTST1.eyua.net:4042/HelpAPI/api/',
    //tokenPath: 'https://INGURVMUAPPTST1.eyua.net:4042/HelpAPI/api/Token',
    //logoutUrl: 'https://INGURVMUAPPTST1.eyua.net:4042/#/logout',
    //sessionExpireUrl: 'https://INGURVMUAPPTST1.eyua.net:4042/#/sessionexpired',

    //  serviceBaseUrl: 'https://inhelpdesk.ey.net/HelpAPI/api/',
    //  tokenPath: 'https://inhelpdesk.ey.net/HelpAPI/api/Token',
    //  logoutUrl: 'https://inhelpdesk.ey.net/#/logout',
    //  sessionExpireUrl: 'http://inhelpdesk.ey.net/#/sessionexpired',

    // FOR QA  :
    // serviceBaseUrl: 'https://inqa1.ey.com/HelpDesk/HelpAPI/api/',
    // tokenPath: 'https://inqa1.ey.com/HelpDesk/HelpAPI/api/Token',
    // logoutUrl: 'https://inqa1.ey.com/HelpDesk/#/logout',
    // sessionExpireUrl: 'https://inqa1.ey.com/HelpDesk/#/sessionexpired',
    // redirectUri: 'https://inqa1.ey.com/HelpDesk',
    // pageAnalyticsUrl: 'https://inpageanalytics.ey.net/Pages/InsertPageAnalytic.aspx',
    // logPageAnalytics: 'Y',
    // IsHostingEnvAzure: true,
    // logApplicationInsights: 'Y',
    // instrumentationKey: 'b5a3470b-8c32-45b3-8250-dd5d5ffddbcb',
    // authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
    // tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',
    // clientId: 'ab342fc7-1108-416a-bf03-e429099a1d2e',


    // FOR UAT : 
    // serviceBaseUrl: 'https://inhelpdesk-uat.ey.net/HelpAPI/api/',
    // tokenPath: 'https://inhelpdesk-uat.ey.net/HelpAPI/api/Token',
    // logoutUrl: 'https://inhelpdesk-uat.ey.net/#/logout',
    // sessionExpireUrl: 'https://inhelpdesk-uat.ey.net/#/sessionexpired',
    // redirectUri: 'https://inhelpdesk-uat.ey.net/',
    // instrumentationKey: '306905d2-b24a-4274-bf34-a65c81c66ca3',
    // clientId: 'ab342fc7-1108-416a-bf03-e429099a1d2e',
    // pageAnalyticsUrl: 'https://inpageanalytics.ey.net/Pages/InsertPageAnalytic.aspx',
    // logPageAnalytics: 'Y',
    // IsHostingEnvAzure: true,
    // logApplicationInsights: 'Y',
    // authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
    // tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',


    // FOR PROD : 
    serviceBaseUrl: 'https://in-helpdesk.ey.net/HelpAPI/api/',
    tokenPath: 'https://in-helpdesk.ey.net/HelpAPI/api/Token',
    logoutUrl: 'https://in-helpdesk.ey.net/#/logout',
    sessionExpireUrl: 'https://in-helpdesk.ey.net/#/sessionexpired',
    redirectUri: 'https://in-helpdesk.ey.net/',
    instrumentationKey: 'da37a2a8-0d6c-47e8-8bc8-e7f094c362cf',
    clientId: '9ec282fd-8ac8-4147-8181-acaca927e9b3',
    pageAnalyticsUrl: 'https://inpageanalytics.ey.net/Pages/InsertPageAnalytic.aspx',
    logPageAnalytics: 'Y',
    IsHostingEnvAzure: true,
    logApplicationInsights: 'Y',
    authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
    tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',




    // serviceBaseUrl: 'https://ingurvmuapptst1.eyua.net:20206/HelpAPI/api/',
    // tokenPath: 'https://ingurvmuapptst1.eyua.net:20206/HelpAPI/api/Token',
    // logoutUrl: 'https://ingurvmuapptst1.eyua.net:20206/#/logout',
    // sessionExpireUrl: 'https://ingurvmuapptst1.eyua.net:20206/#/sessionexpired',
    // pageAnalyticsUrl: 'https://inpageanalytics.ey.net/Pages/InsertPageAnalytic.aspx',
    // logPageAnalytics: 'Y',
    // redirectUri: 'https://ingurvmuapptst1.eyua.net:20206',
    // IsHostingEnvAzure: true,


};
